import { render, staticRenderFns } from "./VehicleRecord.vue?vue&type=template&id=572bbaeb&scoped=true"
import script from "./VehicleRecord.vue?vue&type=script&lang=js"
export * from "./VehicleRecord.vue?vue&type=script&lang=js"
import style0 from "./VehicleRecord.vue?vue&type=style&index=0&id=572bbaeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572bbaeb",
  null
  
)

export default component.exports